import { lowerCase } from 'lodash';
import { connect } from 'react-redux';

import ParentCollectionBanner from 'components/ParentCollectionBanner';
import ParentCollectionBannerModel from 'models/ParentCollectionBanner';

const mapStateToProps = (state, { banner, isLoading }) => {
  if (!banner) {
    throw new Error(`Could not find banner`);
  }

  const {
    backgroundColor,
    backgroundDesktopImage,
    backgroundMobileImage,
    crossPromotionalDesktopImage,
    crossPromotionalMobileImage,
    layout,
    text,
    textAlignment,
    textColor,
    visibility,
  } = new ParentCollectionBannerModel(banner);

  return {
    backgroundColor,
    backgroundDesktopImage,
    backgroundMobileImage,
    crossPromotionalDesktopImage,
    crossPromotionalMobileImage,
    isLoading,
    layout,
    text,
    textAlignment,
    textColor: lowerCase(textColor),
    visibility,
  };
};

export default connect(mapStateToProps)(ParentCollectionBanner);
